<template>
  <div class="auth-main">
    <el-form ref="loginForm" :model="loginData" :rules="rules" v-if="isHidden" class="login-wrapper">
      <div class="login-img-wrapper" >
        <img :src="this.mxDomain.siderLogo" class="login-img" alt="" v-show="this.mxDomain.title!=='管理中台'" />
      </div>
      <div class="loginTitle">审核中台</div>
      <el-form-item class="input-item" prop="account">
        <el-input class="login-input" size="medium" v-model="loginData.account" placeholder="手机号" prefix-icon="iconfont el-icon-user"></el-input>
      </el-form-item>
      <el-form-item class="input-item" prop="password">
        <el-input class="login-input" size="medium" type="password" v-model="loginData.password" placeholder="密码" prefix-icon="iconfont icon-lock"></el-input>
      </el-form-item>
      <el-form-item class="input-item" style="margin-bottom: 5px !important; margin-top: -5px">
        <SmartCaptcha ref="smartCaptchaRef" @verifySuccess="verifySuccess"></SmartCaptcha>
      </el-form-item>
      <el-form-item>
        <CommonButton :buttonTitle="pwdTiltle" :isDisable="pwdIsDisable" class="login-button" :type="'primary'" @buttonClick="handlerLogin"/>
      </el-form-item>
      <el-button type="text" class="login-way" @click="loginAccount">短信验证码登录</el-button>
    </el-form>

    <el-form ref="loginFormTel" :model="telLoginData" :rules="rulesTel" v-else class="login-wrapper">
      <div class="login-img-wrapper">
        <img :src="this.mxDomain.siderLogo" class="login-img" alt=""  v-show="this.mxDomain.title!=='管理中台'" />
      </div>
      <div class="loginTitle">审核中台</div>
      <el-form-item class="input-item" prop="telephone">
        <el-input placeholder="请输入手机号" size="medium" type="text" class="login-input" v-model="telLoginData.telephone">
          <template slot="prepend">+86</template>
        </el-input>
      </el-form-item>
      <el-form-item class="input-item"  prop="registerCode">
        <el-input placeholder="短信验证码" size="medium" type="text" class="login-input" v-model="telLoginData.registerCode">
          <template slot="append">
            <div>
              <el-button class="get-register" :disabled="!telLoginData.telephone || phoneCode !=='获取手机验证码'" @click="getVerifiCode">{{phoneCode}}</el-button>
            </div>
          </template>
        </el-input>
      </el-form-item >
      <el-form-item class="input-item" style="margin-bottom: 5px !important; margin-top: -5px">
        <SmartCaptcha ref="smartCaptchaRef" @verifySuccess="verifySuccess"></SmartCaptcha>
      </el-form-item>
       <el-form-item>
        <CommonButton :buttonTitle="pwdTiltle" :isDisable="telLogin" class="login-button" :type="'primary'" @buttonClick="handlerLogin" />
      </el-form-item>
      <el-button type="text" class="login-way" @click="loginTel">用户名密码登录</el-button>
    </el-form>

    <el-dialog :visible.sync="dialogVisible" width="30%" top="45vh" :show-close="false" :center="true">
      <div class="slide">
        <SlideCaptcha ref="slideCaptchaRef" @slideVerify="slideVerify"></SlideCaptcha>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import CommonButton from "@/components/CommonButton"
import YunpianVerifition from "@/components/YunpianVerifition"
import SmartCaptcha from "../../components/captchas/SmartCaptcha";
import SlideCaptcha from "../../components/captchas/SlideCaptcha";
export default {
  components: {
    CommonButton,
    YunpianVerifition,
    SmartCaptcha,
    SlideCaptcha
  },
  data() {
    return {
      phoneCode: '获取手机验证码',
      timer: null,
      dialogVisible: false,
      //  默认是 密码登录，当点击获取验证码，滑动验证通过后，修改为 短信登录， 点击登录按钮时判断 loginType,发送不同的数据请求
      loginType: 'password', // password, sms
      slideScene: 'nc_message', //  滑动验证的 scene
      smartScene: 'ic_login', //  智能验证的 scene

      refreshJwt: 0,
      title: '',
      pwdIsDisable: false,
      telIsDisable: false,
      telLogin: false,
      pwdTiltle: '登录',
      wait: 0,
      activeName: 'login1',
      isVisible: false,
      isHidden: true,
      codeText:'获取验证码',
      loginData: {
        account: '',
        password: '',
        authenticate: '',
        token: ''
      },
      //手机登录数据
      telLoginData: {
        telephone: '',
        registerCode: ''
      },
      //手机号登录表单验证
      rulesTel: {
        telephone: [
          { required: true, message: '输入手机号', trigger: 'blur' },
          { max: 11, message: '请输入11位手机号' },
        ],
        registerCode: [
          { required: true, message: '输入短信验证码', trigger: 'blur'}
        ]
      },
      // 表单验证
      rules: {
        account: [
          {required: true, message: '输入手机号', trigger: 'blur' },
        ],
        password: [
          {required: true, message: '输入密码', trigger: 'blur' },
        ],
      },
    }
  },
  methods: {
    ...mapMutations({
      setUserIsLogin  : 'user/setUserIsLogin',
    }),
    ...mapMutations([
      'handleUserInfo'
    ]),
    smsCountDown() {
      let count = 60
      this.timer = setInterval(()=> {
        if (count >0 && count <= 60) {
          count--
          this.phoneCode = `${count}秒重新发送`
        } else {
          clearInterval(this.timer)
          this.timer = null
          this.phoneCode = '获取手机验证码'
        }
      }, 1000)
    },
    async slideVerify(value) {
      if (value) {
        this.dialogVisible = false
        this.telLoginData.sessionId = value.sessionId
        this.telLoginData.token = value.token
        this.telLoginData.sig = value.sig
        this.telLoginData.scene = this.slideScene
        try {
          let result  = await this.$api.smsSend({
            mobile: this.telLoginData.telephone
          })
          if (result) {
            this.$message.success("验证码发送成功")
            this.smsCountDown()
            this.$refs.slideCaptchaRef.reloadSlideCap()
          }
        } catch (err) {
          this.telLoginData.sessionId = null
          this.$refs.slideCaptchaRef.reloadSlideCap()
        }
      } else {
        this.telLoginData.sessionId = null
        this.$refs.slideCaptchaRef.reloadSlideCap()
      }
    },
    verifySuccess(value) {
      if (value) {
        this.loginData.sessionId = value.sessionId
        this.loginData.sig = value.sig
        this.loginData.scene = this.smartScene
        this.loginData.token = value.token
      } else {
        this.loginData.sessionId = null
        this.$refs.smartCaptchaRef.reloadSmartCaptcha()
      }
    },
    handlerLogin() {
      if (this.loginType === 'password') {
        console.log("账号密码登录")
        this.accountLogin()
      } else {
        console.log("短信验证码登录")
        this.smsLogin()
      }
    },
    //  账号、密码登录
    accountLogin() {
      this.$refs['loginForm'].validate(async (valid) => {
        if (valid) {
          if (this.loginData.sessionId) {
            try {
              const {access_token: token} = await this.$api.submitLoginInfo({
                account: this.loginData.account,
                password:this.loginData.password,
                session_id:this.loginData.sessionId,
                token:this.loginData.token,
                sig:this.loginData.sig,
                scene:this.loginData.scene
              })
              if (token) {
                this.loginData = {}
                await this.getUserDetail(token)
				await	this.$store.dispatch('getUserPermissions')
				console.log(localStorage.permission)
                this.$message.success('登录成功')
                this.$refs.smartCaptchaRef.reloadSmartCaptcha()
                this.go()
              } else {
                this.$message.error('登录失败')
                this.$refs.smartCaptchaRef.reloadSmartCaptcha()
                this.initRespErrMsgBoxMark()
              }
            } catch (error) {
              this.$refs.smartCaptchaRef.reloadSmartCaptcha()
              this.loginData.sessionId = null
              console.log("login error", error)
            }
          } else {
            this.$message.error('请先点击验证按钮开始验证')
          }
        } else {
          this.$message.error('登录失败，请检查必填项数据！')
        }
      })
    },
    smsLogin() {
      this.telLogin = true
      this.$refs['loginFormTel'].validate(async (valid) => {
        if (valid) {
          if (this.loginData.sessionId) {
            try {
              const { access_token: token } = await this.$api.submitCodeLogin({
                mobile: this.telLoginData.telephone,
                code: this.telLoginData.registerCode,
                session_id:this.loginData.sessionId,
                token:this.loginData.token,
                sig:this.loginData.sig,
                scene:this.loginData.scene
              })
              if (token) {
                await this.getUserDetail(token)
                this.$message.success('登录成功！')
			await	this.$store.dispatch('getUserPermissions')
			console.log(localStorage.permission)
                this.go()
              } else {
                this.$message.error('登录失败')
                this.loginData.sessionId = null
                this.$refs.smartCaptchaRef.reloadSmartCaptcha()
                this.initRespErrMsgBoxMark()
              }
            } catch (error) {
              this.$refs.smartCaptchaRef.reloadSmartCaptcha()
              this.loginData.sessionId = null
              console.log("=========formSubmit", error)
            }
          } else {
            this.$message.error("请先点击验证按钮开始验证")
          }
        } else {
          this.$message.error('登录失败，请检查必填项数据！')
        }
      })
      this.telLogin = false
    },

    async getVerifiCode() {
      if(!this.telLoginData.telephone) {
        this.$message.error('请先输入手机号')
      } else {
        this.loginType = 'sms'
        this.dialogVisible = true
      }
    },
    //验证验证码
    async smsVerify() {
      let args = {
        mobile: this.telLoginData.telephone,
        code: this.telLoginData.registerCode,
      }
      if (this.telLoginData.sessionId) {
        try {
          let result = await this.$api.smsVerify(args)
          if(result) {
            await this.smsLogin()
          } else {
            this.telLoginData.sessionId = null
            this.$refs.slideCaptchaRef.reloadSlideCap()
          }
        } catch (err) {
          this.telLoginData.sessionId = null
          this.$refs.slideCaptchaRef.reloadSlideCap()
        }
      } else {
        this.$message.warning('请先完成验证');
      }
    },
    //  验证码页面的  登录按钮
    handlerSMSLogin() {
      this.$refs['loginFormTel'].validate((valid) => {
        if (valid) {
          console.log("ssss", this.telLoginData.sessionId)
          if (this.telLoginData.sessionId) {
            //  校对验证码是否正确
            this.smsVerify()
          } else {
            this.$message.warning('请先获取验证码');
          }
        } else {
          this.$message.error('登录失败，请检查必填项数据！')
        }
      })
    },
    //获取登录用户信息
    async getUserDetail(token) {
		this.$storage.set('jwt', token)
		this.$storage.set('jwtTime', Date.parse(new Date()))
		this.mxInitSwitch()
		let userinfo = await this.$api.getUserDetail()
		// console.log("userinfo",userinfo1)
		// let userinfo = {"fullname":"审核中台"};
		// console.log('userinfo', userinfo)
		if (userinfo) {
			this.$storage.set('user_info', userinfo)
			this.handleUserInfo(userinfo)
		} else {
			this.$message.error('获取用户信息失败')
		}
    },
    //登录方式
    loginAccount() {
      this.isVisible = true;
      this.isHidden = false;
      // this.$refs.smartCaptchaRef.reloadSmartCaptcha()
      this.loginType = 'sms'
    },
    loginTel() {
      this.isVisible = false;
      this.isHidden = true;
      this.loginType = 'password'
      // this.$refs.slideCaptchaRef.reloadSlideCap()
    },
    //路由跳转
    go(url='/') {//跳转首页
      this.mxRedirect(url)
    },
    // 初始化响应错误弹窗标志
    initRespErrMsgBoxMark() {
      this.$store.commit('changeRespErrMsgBoxMark',false)
    }
  },
  mounted() {
    this.initRespErrMsgBoxMark()
		this.loginInit()
  },
}
</script>

<style lang="stylus" scoped>
  .auth-main
    margin 0 auto
    padding: 20px
    background: #fff
    border-radius: 5px
  .loginTitle
    height: 41px
    line-height: 26px
    color: rgba(24, 144, 255, 100)
    font-size: 18px
    text-align: center
    font-family: -apple-system
    font-weight: bolder
    margin-top: 10px
    margin-bottom: 20px
  .input-item
    margin-bottom 25px !important
  // .input-item:last
  //   margin-bottom 50px !important
  .login-input .el-input__inner
    height 50px
  .el-tabs__nav-wrap::after
    height 0px
  .el-tabs__nav
    display inline-block
    float none
  .el-tabs__header
    text-align center
  .el-input__prefix
    left 8px
  .el-tabs__header
    margin-bottom 24px
  .login-button
    width 100%
    height 50px
    margin-top 15px
    border none
  .login-button:hover
    background #48B4FF
  .get-register
    width: 120px
  .el-form-item
    margin-bottom 5px
  .el-form-item__conten
    height: 50px
  .login-way
    font-size: 14px
    color: #606266
  .login-wrapper
    margin-top: -25px
  .remember
    color: #757575
  .password
    display: flex
    flex-direction: row
    justify-content: space-between
    margin-top: 30px
  .login-wrapper
    width: 300px
  .login-img-wrapper
    padding-top: 30px
    display: flex
    justify-content center
  .login-img
    width: 48px
    height: 48px

>>>.nc_wrapper
  margin 0 auto
>>>.el-dialog__body
  padding-bottom 50px
</style>
